import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentEventTypeDto extends EpimsBaseEntityDto {
  
  EventName: string;
  EventDescription: string;
  SubscriptionUserId: string;  
  Version: number;
  ImageIconPath: string;
  DisplayOrder: number;
}
